@file:OptIn(InternalResourceApi::class)

package helpmycity.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/helpmycity.shared.generated.resources/"

@delegate:ResourceContentHash(-417_311_710)
internal val Res.string.review_reject_reason_label: StringResource by lazy {
      StringResource("string:review_reject_reason_label", "review_reject_reason_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15135, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14171, 62),
      ))
    }

@delegate:ResourceContentHash(391_789_142)
internal val Res.string.review_reject_reason_required: StringResource by lazy {
      StringResource("string:review_reject_reason_required", "review_reject_reason_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15194, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14234, 77),
      ))
    }

@delegate:ResourceContentHash(1_406_635_208)
internal val Res.string.review_rejected_reason: StringResource by lazy {
      StringResource("string:review_rejected_reason", "review_rejected_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15280, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14312, 46),
      ))
    }

@delegate:ResourceContentHash(1_745_072_501)
internal val Res.string.review_rejected_submitter: StringResource by lazy {
      StringResource("string:review_rejected_submitter", "review_rejected_submitter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15327, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14359, 157),
      ))
    }

@delegate:ResourceContentHash(-159_815_817)
internal val Res.string.review_rejected_title: StringResource by lazy {
      StringResource("string:review_rejected_title", "review_rejected_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15485, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14517, 41),
      ))
    }

@delegate:ResourceContentHash(-1_731_324_128)
internal val Res.string.review_reviewed_by: StringResource by lazy {
      StringResource("string:review_reviewed_by", "review_reviewed_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15561, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14589, 42),
      ))
    }

@delegate:ResourceContentHash(-1_811_149_453)
internal val Res.string.review_section_title: StringResource by lazy {
      StringResource("string:review_section_title", "review_section_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15604, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14632, 36),
      ))
    }

@delegate:ResourceContentHash(1_032_354_897)
internal val Res.string.role_admin: StringResource by lazy {
      StringResource("string:role_admin", "role_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15645, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14669, 26),
      ))
    }

@delegate:ResourceContentHash(-625_325_131)
internal val Res.string.role_manager: StringResource by lazy {
      StringResource("string:role_manager", "role_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15684, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14696, 32),
      ))
    }

@delegate:ResourceContentHash(-1_471_019_534)
internal val Res.string.role_resident: StringResource by lazy {
      StringResource("string:role_resident", "role_resident", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15713, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14729, 33),
      ))
    }

@delegate:ResourceContentHash(1_718_324_096)
internal val Res.string.sign_in_action: StringResource by lazy {
      StringResource("string:sign_in_action", "sign_in_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15747, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14763, 34),
      ))
    }

@delegate:ResourceContentHash(1_426_759_037)
internal val Res.string.sign_in_display_name: StringResource by lazy {
      StringResource("string:sign_in_display_name", "sign_in_display_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15790, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14798, 40),
      ))
    }

@delegate:ResourceContentHash(-1_037_729_254)
internal val Res.string.sign_in_email: StringResource by lazy {
      StringResource("string:sign_in_email", "sign_in_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15831, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14839, 29),
      ))
    }

@delegate:ResourceContentHash(1_829_199_720)
internal val Res.string.sign_in_password: StringResource by lazy {
      StringResource("string:sign_in_password", "sign_in_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15881, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14869, 36),
      ))
    }

@delegate:ResourceContentHash(-668_001_838)
internal val Res.string.sign_in_subtitle: StringResource by lazy {
      StringResource("string:sign_in_subtitle", "sign_in_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16060, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15020, 164),
      ))
    }

@delegate:ResourceContentHash(716_511_351)
internal val Res.string.sign_in_subtitle_demo: StringResource by lazy {
      StringResource("string:sign_in_subtitle_demo", "sign_in_subtitle_demo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 15922, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14906, 113),
      ))
    }

@delegate:ResourceContentHash(-1_106_482_726)
internal val Res.string.sign_in_switch_to_sign_in: StringResource by lazy {
      StringResource("string:sign_in_switch_to_sign_in", "sign_in_switch_to_sign_in", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16253, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15185, 77),
      ))
    }

@delegate:ResourceContentHash(544_405_203)
internal val Res.string.sign_in_switch_to_sign_up: StringResource by lazy {
      StringResource("string:sign_in_switch_to_sign_up", "sign_in_switch_to_sign_up", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16331, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15263, 69),
      ))
    }

@delegate:ResourceContentHash(1_718_324_096)
internal val Res.string.sign_in_title: StringResource by lazy {
      StringResource("string:sign_in_title", "sign_in_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16401, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15333, 33),
      ))
    }

@delegate:ResourceContentHash(-1_885_506_705)
internal val Res.string.sign_out: StringResource by lazy {
      StringResource("string:sign_out", "sign_out", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16443, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15367, 28),
      ))
    }

@delegate:ResourceContentHash(-1_318_785_739)
internal val Res.string.sign_up_action: StringResource by lazy {
      StringResource("string:sign_up_action", "sign_up_action", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16480, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15396, 42),
      ))
    }

@delegate:ResourceContentHash(-216_089_795)
internal val Res.string.sign_up_title: StringResource by lazy {
      StringResource("string:sign_up_title", "sign_up_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16519, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15439, 45),
      ))
    }

@delegate:ResourceContentHash(2_075_324_986)
internal val Res.string.signed_in_as: StringResource by lazy {
      StringResource("string:signed_in_as", "signed_in_as", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16565, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15485, 44),
      ))
    }

@delegate:ResourceContentHash(-685_928_690)
internal val Res.string.status_complete: StringResource by lazy {
      StringResource("string:status_complete", "status_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16622, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15530, 35),
      ))
    }

@delegate:ResourceContentHash(1_375_320_786)
internal val Res.string.status_field: StringResource by lazy {
      StringResource("string:status_field", "status_field", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16662, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15566, 36),
      ))
    }

@delegate:ResourceContentHash(1_211_446_426)
internal val Res.string.status_in_progress: StringResource by lazy {
      StringResource("string:status_in_progress", "status_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16699, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15603, 42),
      ))
    }

@delegate:ResourceContentHash(1_276_450_066)
internal val Res.string.status_in_review: StringResource by lazy {
      StringResource("string:status_in_review", "status_in_review", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16738, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15646, 36),
      ))
    }

@delegate:ResourceContentHash(-1_927_675_351)
internal val Res.string.status_open: StringResource by lazy {
      StringResource("string:status_open", "status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16779, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15683, 27),
      ))
    }

@delegate:ResourceContentHash(-159_815_817)
internal val Res.string.status_rejected: StringResource by lazy {
      StringResource("string:status_rejected", "status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16811, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15711, 35),
      ))
    }

@delegate:ResourceContentHash(664_571_705)
internal val Res.string.sync_failed: StringResource by lazy {
      StringResource("string:sync_failed", "sync_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16847, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15747, 43),
      ))
    }

@delegate:ResourceContentHash(1_933_169_516)
internal val Res.string.sync_idle: StringResource by lazy {
      StringResource("string:sync_idle", "sync_idle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16911, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15791, 45),
      ))
    }

@delegate:ResourceContentHash(1_784_657_463)
internal val Res.string.sync_no_backend: StringResource by lazy {
      StringResource("string:sync_no_backend", "sync_no_backend", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 16969, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15837, 123),
      ))
    }

@delegate:ResourceContentHash(120_213_881)
internal val Res.string.sync_now: StringResource by lazy {
      StringResource("string:sync_now", "sync_now", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17129, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15961, 28),
      ))
    }

@delegate:ResourceContentHash(2_009_194_350)
internal val Res.string.sync_status: StringResource by lazy {
      StringResource("string:sync_status", "sync_status", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17170, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15990, 35),
      ))
    }

@delegate:ResourceContentHash(-2_019_008_782)
internal val Res.string.sync_synced: StringResource by lazy {
      StringResource("string:sync_synced", "sync_synced", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17226, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16026, 27),
      ))
    }

@delegate:ResourceContentHash(710_821_692)
internal val Res.string.sync_syncing: StringResource by lazy {
      StringResource("string:sync_syncing", "sync_syncing", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 17262, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16054, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("review_reject_reason_label", Res.string.review_reject_reason_label)
  map.put("review_reject_reason_required", Res.string.review_reject_reason_required)
  map.put("review_rejected_reason", Res.string.review_rejected_reason)
  map.put("review_rejected_submitter", Res.string.review_rejected_submitter)
  map.put("review_rejected_title", Res.string.review_rejected_title)
  map.put("review_reviewed_by", Res.string.review_reviewed_by)
  map.put("review_section_title", Res.string.review_section_title)
  map.put("role_admin", Res.string.role_admin)
  map.put("role_manager", Res.string.role_manager)
  map.put("role_resident", Res.string.role_resident)
  map.put("sign_in_action", Res.string.sign_in_action)
  map.put("sign_in_display_name", Res.string.sign_in_display_name)
  map.put("sign_in_email", Res.string.sign_in_email)
  map.put("sign_in_password", Res.string.sign_in_password)
  map.put("sign_in_subtitle", Res.string.sign_in_subtitle)
  map.put("sign_in_subtitle_demo", Res.string.sign_in_subtitle_demo)
  map.put("sign_in_switch_to_sign_in", Res.string.sign_in_switch_to_sign_in)
  map.put("sign_in_switch_to_sign_up", Res.string.sign_in_switch_to_sign_up)
  map.put("sign_in_title", Res.string.sign_in_title)
  map.put("sign_out", Res.string.sign_out)
  map.put("sign_up_action", Res.string.sign_up_action)
  map.put("sign_up_title", Res.string.sign_up_title)
  map.put("signed_in_as", Res.string.signed_in_as)
  map.put("status_complete", Res.string.status_complete)
  map.put("status_field", Res.string.status_field)
  map.put("status_in_progress", Res.string.status_in_progress)
  map.put("status_in_review", Res.string.status_in_review)
  map.put("status_open", Res.string.status_open)
  map.put("status_rejected", Res.string.status_rejected)
  map.put("sync_failed", Res.string.sync_failed)
  map.put("sync_idle", Res.string.sync_idle)
  map.put("sync_no_backend", Res.string.sync_no_backend)
  map.put("sync_now", Res.string.sync_now)
  map.put("sync_status", Res.string.sync_status)
  map.put("sync_synced", Res.string.sync_synced)
  map.put("sync_syncing", Res.string.sync_syncing)
}
